module.exports = __webpack_public_path__ + "img/168-2ae320.png";